/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import styled from 'styled-components';
import { DropdownMenu } from 'components';
import { customDropdownMenuStyles } from 'styles';

const dropdownMenuStyleTweaks = {
  controlPadding: '0 18px 0 59px',
  fontSize: '14px',
  height: '40px',
  margin: 0,
  position: 'relative',
  zIndex: -1,
  dropdownIndicator: {
    height: '40px',
    width: '40px',
    padding: '10px'
  }
};

function MobileStairFilters({
  filterNames,
  subFilterNames,
  activeFilter,
  activeSubFilter,
  setShowStairFiltersDialog,
  setShowStairSubFiltersDialog
}) {
  const filterOptions = filterNames.map((filterName) => ({
    label: filterName,
    value: filterName
  }));

  const subFilterOptions = subFilterNames.map((subFilterName) => ({
    label: subFilterName,
    value: subFilterName
  }));

  const handleKeyDown = ({ e, callback }) => {
    if (['Space', 'Enter'].includes(e.code) && callback) {
      callback();
    }
  };

  return (
    <Container>
      <span>Filter by:</span>
      <div role="button" tabIndex={0} onClick={() => setShowStairFiltersDialog(true)}>
        <DropdownMenu
          options={filterOptions}
          value={filterOptions.filter(({ value }) => value === activeFilter)}
          placeholder={activeFilter}
          // onKeyDown={(e) =>
          //   handleKeyDown({
          //     e,
          //     callback: () => setShowStairFiltersDialog((currentValue) => !currentValue)
          //   })
          // }
          // onChange={() => setShowStairFiltersDialog(false)}
          openMenuOnClick={false}
          styles={customDropdownMenuStyles(dropdownMenuStyleTweaks)}
          isSearchable={false}
        />
      </div>
      <span>{activeFilter}:</span>
      <div role="button" tabIndex={0} onClick={() => setShowStairSubFiltersDialog(true)}>
        <DropdownMenu
          options={subFilterOptions}
          value={subFilterOptions.filter(({ value }) => value === activeSubFilter)}
          placeholder={activeSubFilter}
          openMenuOnClick={false}
          // onKeyDown={(e) =>
          //   handleKeyDown({
          //     e,
          //     callback: () => setShowStairSubFiltersDialog((currentValue) => !currentValue)
          //   })
          // }
          // onChange={() => setShowStairSubFiltersDialog((currentValue) => !currentValue)}
          styles={customDropdownMenuStyles(dropdownMenuStyleTweaks)}
          isSearchable={false}
        />
      </div>
    </Container>
  );
}

const Container = styled.div`
  cursor: pointer;
  display: grid;
  gap: 26px 28px;
  grid-template-columns: auto auto;
  justify-content: center;
  margin-bottom: 30px;
  place-items: center start;

  svg {
    width: 19px;
  }

  @media (width >= 590px) {
    justify-content: start;
  }

  > span {
    color: var(--connolly-red);
  }
`;

export default MobileStairFilters;
